import React from 'react';
export function Guarantee() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#0a0a0a',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-164">
      <div className="mx-auto max-w-3xl text-center" data-id="element-165">
        {/* Shield Icon */}
        <div className="mb-4 text-[64px] leading-[64px]" data-id="element-166">🛡️</div>

        {/* Heading */}
        <h2 className="text-3xl font-black leading-10 text-yellow-400 m-0 mb-4" data-id="element-167">
          GARANTÍA DETAILER PRO™ — 30 DÍAS
        </h2>

        {/* Guarantee Card */}
        <div className="mb-6 rounded-xl p-6 border-2 border-yellow-400 shadow-sm" style={{
        backgroundColor: 'rgba(234, 179, 8, 0.05)'
      }} data-id="element-168">
          <p className="text-base leading-[24px] text-gray-200 m-0 mb-3" data-id="element-169">
            Abrís los 6 tomos. Revisás los 4 bonos. Aplicás los protocolos en tu
            primer trabajo si querés.
          </p>
          <p className="text-base leading-[24px] text-gray-200 m-0 mb-4" data-id="element-170">
            Si en 30 días no mejoraste tu técnica, no conseguiste nuevos
            clientes o no te gustó el sistema:
          </p>
          <p className="text-2xl font-black text-yellow-400 m-0 mb-3" data-id="element-171">
            Te devolvemos el 100%.
          </p>
          <p className="text-lg font-bold text-white m-0" data-id="element-172">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        {/* Fine Print */}
        <p className="text-xs leading-[20px] text-gray-500 m-0" data-id="element-173">
          La confianza que tenemos en el MegaPack Detailer Argentino nos permite
          hacer esa promesa sin dudar.
          <br data-id="element-174" />
          Más de 1.240 detailers de todo el país ya lo saben.
          <br data-id="element-175" />
          La tasa de devoluciones es menor al 1%.
        </p>
      </div>
    </section>;
}